module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAACXBIWXMAABYlAAAWJQFJUiTwAAABL0lEQVRYhe2YvRWCMBRGP38GsLSktLSls7VzBTfwsYDHBcgItm6hnZS6gSM4godzUkAISVR4gL5bkgCX5MsLJxCEH2Pk+pyEKAIQdfHJqVKXujardEI0A7AHsGvVzM0DwNYmP6657dixMPQMnxOipdlQkdadNmxqfvZmD9tIz3ogWqSypqYhd6VKORdskyREqzwWhUf64zEEBikdFI930OWyNKWumtsLaS18Nq41uiYk01yINBdvL0SO6uDjk+rRenXwIZnmQqS5aGMbd9JE9WGXbqL6SKa5EGkuRJqL/9hc9EZQW1e/bQ9B4sFFUDz0URUXlWMwk9BMm/8KnNzMd9niUenUMX7pVKkngENPhHMXMi9ObD2vWXaJ4/gOYAFgzqJXJpc9AVjrQRSE3wXAC4OrPVuh9wHjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/89.png
// module id = QgBW
// module chunks = 1